// src/lib/api/suppliers.js
import directus from './directus';
import { readItems } from '@directus/sdk';

export const fetchApprovedSuppliers = async () => {
  try {
    const suppliers = await directus.request(
      readItems('supplier_applications', {
        filter: {
          status: { _eq: 'published' }
        },
        fields: ['id', 'company_name', 'category'],
        limit: -1 // 获取全部
      })
    );
    return suppliers; // 返回数组
  } catch (error) {
    console.error('获取供应商失败:', error);
    throw error;
  }
};